import { SnackbarProvider, useSnackbar } from '../helpers/hooks/useSnackbar'

import Snackbar from './Snackbar/Snackbar'

const Root = ({ children }) => {
  return (
    <SnackbarProvider>
      {children}
      <SnackbarComponent />
    </SnackbarProvider>
  )
}

const SnackbarComponent = () => {
  const { snackbar } = useSnackbar()
  return <Snackbar {...snackbar} />
}

export default Root
